import { Controller } from '@hotwired/stimulus';
import Rails from "@rails/ujs";
import debounce from 'lodash.debounce';

export default class extends Controller {
  static targets = [ 'checkbox', 'query', 'clearButton' ];

  connect(){
    this.boundUpdateURL = this.updateURL.bind(this);
    this.element.addEventListener('turbo:submit-end', this.boundUpdateURL);
    this.element.addEventListener('submit', this.handleSubmit.bind(this));
    this.processFilterCountMutation(this.element);
    this.debouncedSubmit = debounce(this.submit.bind(this), 400);
    this.jsTriggered = false;
  }

  submit() {
    this.jsTriggered = true;
    Rails.fire(this.element, 'submit');
  }

  handleSubmit(event) {
    if (!this.jsTriggered && this.hasQueryTarget) {
      this.queryTarget.blur();
    }
    this.jsTriggered = false;
  }

  clearQuery() {
    this.queryTarget.value = '';
    this.toggleClearButton();
    this.submit();
    setTimeout(() => {
      this.queryTarget.focus();
    }, 50);
  }

  toggleClearButton() {
    if (this.hasClearButtonTarget) {
      if (this.queryTarget.value.trim() === '') {
        this.clearButtonTarget.classList.add('hidden');
      } else {
        this.clearButtonTarget.classList.remove('hidden');
      }
    }
  }

  updateURL(event) {
    // Push state or replace state?
    // Turbo.navigator.history.replace
    window.history.pushState(window.history.state, null, event.detail.fetchResponse.response.url);
  }

  queryTargetConnected(target) {
    target.addEventListener('input', () => {
      this.toggleClearButton();
      this.debouncedSubmit();
    });
  }

  checkboxTargetConnected(target) {
    target.addEventListener('change', () => {
      this.submit();
    });
  }

  processFilterCountMutation(element) {
    const config = { childList: true, subtree: true, characterData: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if ( mutation.target.classList.contains('filter-count') ){
          const activeFilterCount = parseInt(mutation.target.innerHTML);
          if ( activeFilterCount > 0){
            mutation.target.classList.remove('hidden');
          } else {
            mutation.target.classList.add('hidden');
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(element, config);

    // Later, you can stop observing
    // observer.disconnect();
  }
}
